/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-17 12:36:08
 * @LastEditors: Json Chen
 * @LastEditTime: 2021-06-22 11:41:48
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/DraggableModules/Components/ArticleCarousel/index.tsx
 */
import React from 'react';
import { ContentModuleGroupPreloadingContext } from 'src/constrains/DraggableModules/PreloadComponent/SubscriptionPreloading';
import _ArticleCarousel from 'src/components/Modules/ArticleCarousel';
import ContentGroupHOC from '../HOC';
import { errKeys } from 'src/constrains/DraggableModules/tools';
import { EnumModuleType } from 'src/types/common/module';

const ArticleCarousel = (props) => {
  const {
    staticData,
    dynamicData,
    handleOnItemDelete,
    handleItemOnAdd,
    handleItemOnChange,
    handleItemOnSort,
    handleOnStaticsChange,
    specificError,
    droppableId,
    draggableId,
  } = props || {};
  const { options } = React.useContext(ContentModuleGroupPreloadingContext);
  const _errKeys = errKeys[EnumModuleType.ArticleCarousel];

  return (
    <_ArticleCarousel
      contentPageList={options}
      configFieldsList={dynamicData}
      specificError={specificError}
      draggableId={draggableId}
      staticData={staticData}
      droppableId={droppableId}
      onItemDelete={handleOnItemDelete}
      onItemAdd={handleItemOnAdd}
      onItemChange={handleItemOnChange}
      onItemSort={handleItemOnSort}
      onStaticChange={handleOnStaticsChange}
      errKeys={_errKeys}
    />
  );
};
export default ContentGroupHOC(ArticleCarousel);
